import React, { useState, useCallback } from "react";
import { Link } from "react-router-dom"
import { useDispatch } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, Card, CardBody, Table, Button, Alert } from "reactstrap";

import { v4 as uuidv4 } from 'uuid';

import Dropzone from "react-dropzone";
import Dragula from 'react-dragula';

import { addPartImages } from "../slices/thunks";

const UploadModal = ({itemId, itemContents, show, onCloseClick}) => {
    
    const dispatch = useDispatch();
    const [files, setFiles] = useState([]);
    
    function handleAcceptedFiles(uploadedFiles) {  
        let i = files.length; 
        uploadedFiles.map(file =>{
            i++;
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                id: uuidv4(),
                index: i
            })
        });
        setFiles([...files, ...uploadedFiles]);
    }

    const deleteFile = (file) => {
        const modifiedFileList = files.filter(item => item.id != file.id);
        let i = 0;
        modifiedFileList.forEach(item => {
            i++;
            item.index = i;
        })
        setFiles(modifiedFileList);
    }

    var container = document.getElementById("image-container");
    var rows = !container ? [] : container.children || [];
    var nodeListForEach = function (array, callback, scope) {
        for (var i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i])
        }};
    var sortableTable = Dragula([container]);
    sortableTable.on('dragend', function() {
        nodeListForEach(rows, function (index, row) {
            row.dataset.rowPosition = index + 1;
        });
    });

    const handleFormSubmit = (e) => {
        e.preventDefault();
        let images = [];
        for(var i = 0; i < rows.length; i++) {
            let file = files.find(f => f.id == rows[i].id);
            file.index = i + 1;
            images.push(file);
        }
        const newImages = {
            id: itemId,
            images: images
        };
        dispatch(addPartImages(newImages));
        handleOnCloseClick();
        return false;
    };
  
    const handleOnCloseClick = useCallback(() => {
        setFiles([]);
        onCloseClick();
    });

    return (
        <Modal id="uploadModal" isOpen={show} toggle={handleOnCloseClick} centered backdrop={'static'}>
            <ModalHeader className="bg-light p-3" toggle={handleOnCloseClick}> Dodaj slike </ModalHeader>
            <Form className="tablelist-form" onSubmit={handleFormSubmit}>
            <ModalBody>
                {!(files.length > 0) && (<Alert color="danger" className="text-center fs-20">Morate dodati bar jednu sliku!</Alert>)}
                {files.length > 10 && (<Alert color="danger" className="text-center fs-20">Dodali ste {files.length} slika, što je više od 10 slika.</Alert>)}
                <Card>
                    <CardBody>
                        <Dropzone onDrop={acceptedFiles => {handleAcceptedFiles(acceptedFiles)}}>
                            {({ getRootProps, getInputProps }) => (
                                <div className="dropzone dz-clickable" {...getRootProps()}>
                                <input {...getInputProps()} />
                                    <div className="dz-message needsclick">
                                        <i className="display-5 text-muted ri-upload-cloud-2-fill" />
                                        <p>Drop files here or click to upload.</p>
                                    </div>
                                </div>
                            )}
                        </Dropzone>
                        <div className="list-unstyled mb-0" id="file-previews">
                            <div className="table-responsive mb-1">
                                <Table className="align-middle table table-borderless">
                                    <tbody id="image-container">{files.map(f => {
                                        return(
                                            <tr id={f.id} key={f.id} className="dz-processing dz-image-preview dz-success dz-complete">                                
                                                <td className="d-inline-block text-truncate" style={{maxWidth: 400}}>
                                                    <img src={f.preview} alt={f.name} className="avatar-md rounded me-2" data-dz-thumbnail=""/>
                                                    <Link to="#" className="text-muted fw-bold">{f.name}</Link>
                                                </td>
                                                <td>
                                                    <button className="btn btn-sm btn-soft-danger remove-list" onClick={() => deleteFile(f)}>
                                                        <i className="ri-delete-bin-5-fill align-bottom"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}</tbody>
                                </Table>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </ModalBody>
            <ModalFooter>
                <div className="hstack gap-2 justify-content-end">
                    <Button color="dark" outline onClick={() => {handleOnCloseClick()}}> Zatvori </Button>
                    {(files.length > 0 && files.length < 11) && (<Button color="success" outline type="submit"> Dodaj </Button>)}
                </div>
            </ModalFooter>
            </Form>
        </Modal>
  );
}

export default UploadModal;